import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  @media (max-width: 600px) {
    width: 100%;
  }
`;
